import React from 'react';
import { Axis } from '../../plot/components/Axis';
import { useStrip } from '../../plot/hooks/useStrip';
import { format } from 'd3-format';
import { Scale } from '../../plot/types/scale';

interface Props {
  yScale: Scale;
}

export const ScatterLeftAxis: React.FC<Props> = ({ yScale }) => {
  const { width } = useStrip();

  return (
    <g transform={`translate(${width})`}>
      <Axis
        position='left'
        scale={yScale}
        interval={50}
        formatter={format('d')}
      />
    </g>
  );
};
